import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        {/* Main Footer Content */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl font-bold text-accent-500">可游漫画</span>
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800/50 hover:bg-accent-500/20 text-secondary-300 hover:text-accent-400 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800/50 hover:bg-accent-500/20 text-secondary-300 hover:text-accent-400 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                  版权声明
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-sm text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-secondary-800/60 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 可游漫画网 KeyouManhua.com — 所有漫画内容仅供学习交流使用
          </p>
          <p className="text-xs text-secondary-400">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener" className="hover:text-accent-400 transition-colors duration-200">
              京ICP备2020000001号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}